export default __webpack_public_path__ + "static/media/review_data_of_inc.c90fe382.svg";